module.exports = __webpack_public_path__ + "static/media/best-app-development-tool.467e957b.md";